<template>
  <div>
    <ToolbarAuth />
    <div class="mt-15 ml-15 mr-15">
      <v-card elevation="15" class="mb-15">
        <v-card-title class="primary--text">Noodplan BV {{ bv_planSingle.first_name_client }} {{ bv_planSingle.last_name_client }}</v-card-title>
        <v-simple-table>
          <template v-slot:default>
            <thead></thead>
            <tbody>
              <tr>
                <td class="accent--text">Modules</td>
                <td></td>
              </tr>
              <tr>
                <td>Noodopvolging</td>
                <td v-if="!bv_planSingle.finishModA"><v-btn small color="accent" class="" @click="goModuleA">Vul in</v-btn></td>
                <td v-if="bv_planSingle.finishModA"><v-btn small color="info" class="" @click="goModuleA">Wijzig</v-btn></td>
              </tr>
              <tr>
                <td>Voortzetting door familie</td>
                <td v-if="!bv_planSingle.finishModB"><v-btn small color="accent" class="" @click="goModuleB">Vul in</v-btn></td>
                <td v-if="bv_planSingle.finishModB"><v-btn small color="info" class="" @click="goModuleB">Wijzig</v-btn></td>
              </tr>
              <tr>
                <td>Voortzetting door medewerkers</td>
                <td v-if="!bv_planSingle.finishModC"><v-btn small color="accent" class="" @click="goModuleC">Vul in</v-btn></td>
                <td v-if="bv_planSingle.finishModC"><v-btn small color="info" class="" @click="goModuleC">Wijzig</v-btn></td>
              </tr>
              <tr>
                <td>Verkoop aan een externe partij</td>
                <td v-if="!bv_planSingle.finishModD"><v-btn small color="accent" class="" @click="goModuleD">Vul in</v-btn></td>
                <td v-if="bv_planSingle.finishModD"><v-btn small color="info" class="" @click="goModuleD">Wijzig</v-btn></td>
              </tr>
              <tr>
                <td>Staking activiteiten</td>
                <td v-if="!bv_planSingle.finishModE"><v-btn small color="accent" class="" @click="goModuleE">Vul in</v-btn></td>
                <td v-if="bv_planSingle.finishModE"><v-btn small color="info" class="" @click="goModuleE">Wijzig</v-btn></td>
              </tr>
              <tr>
                <td>Structuur</td>
                <td v-if="!bv_planSingle.finishModF"><v-btn small color="accent" class="" @click="goModuleF">Vul in</v-btn></td>
                <td v-if="bv_planSingle.finishModF"><v-btn small color="info" class="" @click="goModuleF">Wijzig</v-btn></td>
              </tr>
              <tr>
                <td>Mede-eigenaren</td>
                <td v-if="!bv_planSingle.finishModG"><v-btn small color="accent" class="" @click="goModuleG">Vul in</v-btn></td>
                <td v-if="bv_planSingle.finishModG"><v-btn small color="info" class="" @click="goModuleG">Wijzig</v-btn></td>
              </tr>
              <tr>
                <td>Bedrijfsstrategie</td>
                <td v-if="!bv_planSingle.finishModH"><v-btn small color="accent" class="" @click="goModuleH">Vul in</v-btn></td>
                <td v-if="bv_planSingle.finishModH"><v-btn small color="info" class="" @click="goModuleH">Wijzig</v-btn></td>
              </tr>
              <tr>
                <td>Finance & IT</td>
                <td v-if="!bv_planSingle.finishModI"><v-btn small color="accent" class="" @click="goModuleI">Vul in</v-btn></td>
                <td v-if="bv_planSingle.finishModI"><v-btn small color="info" class="" @click="goModuleI">Wijzig</v-btn></td>
              </tr>
              <tr>
                <td>Rol van de ondernemer</td>
                <td v-if="!bv_planSingle.finishModJ"><v-btn small color="accent" class="" @click="goModuleJ">Vul in</v-btn></td>
                <td v-if="bv_planSingle.finishModJ"><v-btn small color="info" class="" @click="goModuleJ">Wijzig</v-btn></td>
              </tr>
              <tr>
                <td>Management en Medewerkers</td>
                <td v-if="!bv_planSingle.finishModK"><v-btn small color="accent" class="" @click="goModuleK">Vul in</v-btn></td>
                <td v-if="bv_planSingle.finishModK"><v-btn small color="info" class="" @click="goModuleK">Wijzig</v-btn></td>
              </tr>
              <tr>
                <td>Leveranciers</td>
                <td v-if="!bv_planSingle.finishModL"><v-btn small color="accent" class="" @click="goModuleL">Vul in</v-btn></td>
                <td v-if="bv_planSingle.finishModL"><v-btn small color="info" class="" @click="goModuleL">Wijzig</v-btn></td>
              </tr>
              <tr>
                <td>Klanten</td>
                <td v-if="!bv_planSingle.finishModM"><v-btn small color="accent" class="" @click="goModuleM">Vul in</v-btn></td>
                <td v-if="bv_planSingle.finishModM"><v-btn small color="info" class="" @click="goModuleM">Wijzig</v-btn></td>
              </tr>
              <tr>
                <td>Adviseurs</td>
                <td v-if="!bv_planSingle.finishModN"><v-btn small color="accent" class="" @click="goModuleN">Vul in</v-btn></td>
                <td v-if="bv_planSingle.finishModN"><v-btn small color="info" class="" @click="goModuleN">Wijzig</v-btn></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeView()" large class="ma-5" color="accent"> {{ $t("crud.close") }}</v-btn>
        </v-card-actions>
      </v-card>
      <v-spacer></v-spacer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
export default {
  name: "userview",
  components: { ToolbarAuth },
  data() {
    return {
      email: "",
      search: "",
      headers: [
        {
          text: this.$t("users.users"),
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "EMAIL", sortable: true, value: "email" },
        { text: this.$t("crud.actions"), value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    closeView() {
      this.$router.push({ name: "bvIndex" });
    },
    goModuleA() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModule-A", params: { id: ClientId } });
    },
    goModuleB() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModule-B", params: { id: ClientId } });
    },
    goModuleC() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModule-C", params: { id: ClientId } });
    },
    goModuleD() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModule-D", params: { id: ClientId } });
    },
    goModuleE() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModule-E", params: { id: ClientId } });
    },
    goModuleF() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModule-F", params: { id: ClientId } });
    },
    goModuleG() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModule-G", params: { id: ClientId } });
    },
    goModuleH() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModule-H", params: { id: ClientId } });
    },
    goModuleI() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModule-I", params: { id: ClientId } });
    },
    goModuleJ() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModule-J", params: { id: ClientId } });
    },
    goModuleK() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModule-K", params: { id: ClientId } });
    },
    goModuleL() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModule-L", params: { id: ClientId } });
    },
    goModuleM() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModule-M", params: { id: ClientId } });
    },
    goModuleN() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModule-N", params: { id: ClientId } });
    },
  },
  computed: {
    ...mapGetters("bvSingle", ["loading", "error", "bv_planSingle"]),
  },
  created() {
    let ClientId = this.$route.params.id;
    this.$store.dispatch("bvSingle/getBVplan", ClientId);
  },
};
</script>

<style scoped></style>
